import Router from 'next/router';

import { Draft, PayloadAction } from '@reduxjs/toolkit';

import pages from 'constants/pages';

import { IAuthData } from '../../initialState';

function logoutRequest(draft: Draft<IAuthData>, _: PayloadAction) {
  draft.authorization.accessToken = null;
  draft.profile.email = undefined;
  draft.profile.id = undefined;
  draft.profile.firstname = undefined;
  draft.profile.lastname = undefined;
  draft.profile.locale = undefined;
  draft.profile.mobile_phone = undefined;
  draft.profile.companyname = undefined;
  draft.profile.matching_locales = [];
  draft.profile.intervention_ids = [];
  draft.profile.vat_number = undefined;
  draft.profile.address = undefined;
  draft.profile.city = undefined;
  draft.profile.phone = undefined;
  draft.profile.intervention_partnership_id = undefined;
  draft.profile.website_url = undefined;
  draft.profile.zip = undefined;
  draft.profile.role = undefined;
  draft.profile.treetrades = [];
  draft.profile.trader_id = undefined;
  draft.profile.company_details = false;
  draft.profile.invoice_permission = false;
  draft.profile.user_management = false;
  draft.profile.all_interventions = false;
  Router.replace(pages.auth);
}

export default logoutRequest;
